import { IMPORT_OPTIONS_SUCCESS_TOAST_MESSAGE_KEY } from '@/features/transaction_items/Detail/components/Drawer/ImportTransactionDetailOptionDrawer/constant';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useEffect } from 'react';

export const useImportOptionsToast = () => {
  const notify = useToastAPI();

  useEffect(() => {
    const message = sessionStorage.getItem(
      IMPORT_OPTIONS_SUCCESS_TOAST_MESSAGE_KEY
    );
    if (!message) return;

    notify.pending({
      title: message,
      duration: 5,
    });
    sessionStorage.removeItem(IMPORT_OPTIONS_SUCCESS_TOAST_MESSAGE_KEY);
  }, [notify]);
};
